import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreUiModule } from '../core-ui';
import { LegacyNavigationMenuComponent } from './legacy-navigation-menu.component';
import { LogoSVGComponent } from './logo.component';
import { MiniNavigationDropdownComponent } from './mini-navigation-dropdown.component';
import { NavigationItemComponent } from './navigation-item.component';
import { NavigationComponent } from './navigation.component';

@NgModule({
    imports: [CommonModule, CoreUiModule, RouterModule],
    declarations: [
        NavigationComponent,
        NavigationItemComponent,
        LegacyNavigationMenuComponent,
        MiniNavigationDropdownComponent,
        LogoSVGComponent
    ],
    exports: [
        NavigationComponent,
        NavigationItemComponent,
        LegacyNavigationMenuComponent,
        MiniNavigationDropdownComponent
    ],
    providers: []
})
export class SiteNavigationModule {}
